import React, { useMemo } from 'react';
import classnames from 'classnames';
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share';

import useOptions from 'hooks/graphql/useOptions';

import * as styles from './share.module.scss';

const Share = ({ title, uri }) => {
  const options = useOptions();
  const { resourceCenterPostInfo } = options.resourceCenterPostInfo;
  const {
    resourceCenterPostInfoShare: { resourceCenterPostInfoShareTitle },
  } = resourceCenterPostInfo;

  const settings = {
    size: 60,
    round: true,
  };

  const urlToShare = useMemo(() => process.env.GATSBY_WEB_URL + uri, [uri]);

  return (
    <section className={classnames(styles.section)}>
      <div>
        <p className={classnames(styles.title, 'scr-txt-up scr-txt-center')}>
          {resourceCenterPostInfoShareTitle}
        </p>

        <ul className={classnames(styles.list)}>
          <li>
            <FacebookShareButton url={urlToShare} title={title}>
              <FacebookIcon size={settings.size} round={settings.round} />
            </FacebookShareButton>
          </li>
          <li>
            <TwitterShareButton url={urlToShare} title={title}>
              <TwitterIcon size={settings.size} round={settings.round} />
            </TwitterShareButton>
          </li>
          <li>
            <EmailShareButton url={urlToShare} body={title} subject={title}>
              <EmailIcon size={settings.size} round={settings.round} />
            </EmailShareButton>
          </li>
          <li>
            <LinkedinShareButton url={urlToShare} title={title}>
              <LinkedinIcon size={settings.size} round={settings.round} />
            </LinkedinShareButton>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Share;
